import { Component } from 'opus-angular-seed-core';
@Component({
    bindings: {
        uibModalInstance: '=',
        form: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'forms.Clone form' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.cloneNameError">
                        <label class="label">{{ 'forms.Form name' | translate }}*</label>
                        <div class="items">
                            <input
                             ng-model="vm.cloneName"
                             type="text" class="form-control"
                             ng-change="vm.validateCloneName()"
                             >
                            <form-row-error ng-show="vm.cloneNameError !== ''">{{ vm.cloneNameError }}</form-row-error>
                        </div>
                    </form-row>
                    <p>{{ "forms.Clone form information" | translate }}</p>
                </form-wrapper>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button ng-if="vm.showSaveButton" class="btn main" type="button" ng-click="vm.save()">{{ 'general.Clone' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $state, $translate, FormResource, toastr) {
        this.$scope = $scope;
        this.$state = $state;
        this.$toastr = toastr;
        this.$translate = $translate;
        this.FormResource = FormResource;
        this.cloneName = '';
    }
    $onInit () {
        this.showSaveButton = true;
        this.cloneName = `Copy - ${(this.form.activeI18n.name || '')}`;
    }

    validateCloneName () {
        if (!this.cloneName || this.cloneName.trim() === '') {
            this.cloneNameError = this.$translate.instant('forms.Form name is required');
        }
        else if (this.cloneName.length > 255) {
            this.cloneNameError = this.$translate.instant('forms.Form name length');
        }
        else {
            this.cloneNameError = '';
        }
    }

    save () {
        this.validateCloneName(); // Ensure validation before save
        if (this.cloneNameError) return; // Prevent saving if validation

        this.showSaveButton = false;
        this.FormResource.cloneForm({}, {
            id: this.form.id,
            name: this.cloneName
        }).$promise
            .then((response) => {
                this.uibModalInstance.close();
                this.$toastr.success(this.$translate.instant('forms.Form successfully cloned'));
                this.$state.go('authorized.forms.forms.form.general', { id: response.id });
            })
            .catch(() => {
                this.uibModalInstance.close();
                this.$toastr.error(
                    this.$translate.instant('forms.Failed to clone the form')
                );
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/forms/clone/index.js